<template>
  <div class="wrapper wrapper-full-page">
    <div
      class="full-page section-image"
      data-color="black"
      data-image="/static/img/full-screen-image-2.jpg"
    >
      <div class="content">
        <div class="container">
          <div class="col-md-4 col-sm-6 ml-auto mr-auto">
            <form class="form" @submit.prevent="submitForm()">
              <div
                class="card card-login"
                v-bind:class="{ 'card-hidden': !pageLoaded }"
              >
                <div class="card-header">
                  <h3 class="header text-center">
                    {{ $t('common.labels.login') }}
                  </h3>
                </div>
                <div class="card-body">
                  <div class="card-body">
                    <div class="form-group">
                      <label>{{ $t('common.labels.email') }}</label>
                      <input
                        v-model="email"
                        name="email"
                        type="email"
                        class="form-control"
                        aria-describedby="emailHelp"
                        :placeholder="$t('common.placeholders.email')"
                        required
                        autocomplete="off"
                      />
                    </div>
                    <div class="form-group">
                      <label>{{ $t('common.labels.password') }}</label>
                      <input
                        v-model="password"
                        name="password"
                        type="password"
                        class="form-control"
                        :placeholder="$t('common.placeholders.password')"
                        required
                        autocomplete="off"
                      />
                    </div>
                  </div>
                </div>
                <div class="card-footer ml-auto mr-auto">
                  <button
                    type="submit"
                    class="btn btn-danger text-white btn-wd"
                  >
                    {{ $t('common.buttons.submit') }}
                  </button>
                  <br />
                </div>
                <div class="clearfix text-center">
                  <router-link
                    to="/register"
                    class="btn btn-simple mr-auto text-info"
                    >{{ $t('common.labels.register') }}</router-link
                  >
                  <br />
                  <forgot-password />
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
      <div
        class="full-page-background"
        style="background-image: url('/static/img/full-screen-image-2.jpg') "
      />
    </div>
  </div>
</template>
<script>
import apiErrors from '@/mixins/api-errors';
import ForgotPassword from '@/components/GeneralViews/ForgotPassword.vue';

export default {
  components: {
    ForgotPassword,
  },
  mixins: [apiErrors],
  data() {
    return {
      email: null,
      password: null,
      pageLoaded: false,
    };
  },
  created() {},
  mounted() {
    setTimeout(() => {
      this.pageLoaded = true;
    }, 20);
  },
  methods: {
    submitForm() {
      this.$http
        .post('/auth/login', {
          email: this.email,
          password: this.password,
        })
        .then((res) => {
          if (res.data) {
            if (
              res.data
              && res.data.user
              && res.data.user.roles.some(
                (v) => ['MODERATOR', 'ADMIN'].indexOf(v) >= 0
              )
            ) {
              this.$store.commit('token', res.data.token);
              this.$store.commit('user', res.data.user);
              setTimeout(() => {
                this.$notifications.clear();
                this.$notify({
                  title: this.$t('common.messages.loginWelcome', {
                    name: `${res.data.user.firstname} ${res.data.user.lastname}`,
                  }),
                  type: 'success',
                });
                this.$router.push('/');
              }, 200);
            } else {
              this.$notify({
                title: this.$t('common.messages.no_access_account'),
                type: 'warning',
              });
            }
          }
        })
        .catch(this.apiErrorCallback);
    },
  },
};
</script>
